import { PlaceholderPage } from './PlaceholderPage';

export const ExportPage = () => <PlaceholderPage title="Export" />;
